import { Injectable, Injector, inject } from '@angular/core';
import { GamesService } from './games.service';
import { map, Observable, switchMap } from 'rxjs';
import { PlatformGraphQlService } from '../graphql/platform-graphql.service';
import { FiltersService } from 'ngx-unificator/services';

@Injectable({
  providedIn: 'root',
})
export class LastPlayedGamesService {

  private _injector = inject(Injector);
  private _platformApi = inject(PlatformGraphQlService);
  private _games = inject(GamesService);
  private _filters = inject(FiltersService);

  /**
   * For avoiding circular dependency
   */
  get gamesService() {
    return this._injector.get(GamesService);
  }

  /**
   * Returns ready to use favorite games list
   */
  getMappedGameList(): Observable<any> {
    let idList: any[] = [];
    return this._platformApi.lastPlayedGamesList(true).pipe(
      map(e => e.data.result.gameSessions.edges.map(e => e.node.game.id)),
      switchMap(identifiers => {
        idList = identifiers;
        return this._games.list({
          'external_id[]': identifiers.length ? identifiers : null,
        });
      }),
      map((response: any) => ({
        ...response,
        gameList: this._filters.sortByArrayOrder(idList, 'externalId', response.gameList)
      }))
    );
  }
}
